<template>
  <div class="page-index content-430">
    <ImportTips></ImportTips>
    <div class="form-content-header">
      <span>选择导入线下订单文件</span>
    </div>
    <div>
      <Form
        ref="formValidate"
        :model="formValidate"
        :rules="ruleValidate"
        label-position="right"
        :label-width="60"
        class="search-list-430 search-wrapper-430 flex"
      >
        <FormItem label="学校:" prop="name">
          <div class="sch-form-item">
            <ChooseApply
              v-if="portOrg != 2"
              ref="chooseSchoolRef"
              :placeholder="`请选择学校`"
              :year-term-code="[formValidate.yearCode, formValidate.termCode]"
              :clearable="true"
              :org-type="`1`"
              @on-change="onSchChange"
            ></ChooseApply>
            <p v-else>{{ userInfo && userInfo.orgName }}</p>
          </div>
        </FormItem>
        <FormItem label="校区:" prop="name">
          <choose-campus
            ref="chooseCampusRef"
            :org-id="formValidate.schoolId"
            :disabled="!formValidate.schoolId"
            :placeholder="Campusplaceholder"
            :isall-campus="true"
            @on-change="handleCampusChange"
          ></choose-campus>
        </FormItem>
        <FormItem label="学期:" prop="name">
          <CascaderYearTerms
            ref="cascaderYearTerms"
            :placeholder="`请选择学期`"
            :clearable="false"
            @on-change="onCascaderChange"
          >
          </CascaderYearTerms>
        </FormItem>
      </Form>
    </div>
    <!-- <ImportSearch @on-search="handleSearch" ref="searchRef"></ImportSearch> -->
    <div class="fileWrap">
      <div class="flex flexrow flexac flexsb">
        <div class="flex flexrow flexac">
          <Button type="primary" @click="handleClick">选择上传文件</Button>
          <Button
            type="text"
            class="downfont"
            @click="downTemplateFile"
          >点击下载导入模板</Button>
          <span class="dfont">支持格式：.xlsx ，单个文件不能超过20MB。</span>
          <input
            ref="uploadInput"
            type="file"
            :uploadType="0"
            accept=".xls,.xlsx"
            class="uploadInput"
            :multiple="false"
            @change="inputFileChage"
          >
        </div>
        <Button
          style="background-color: #3fc55d; border: none; color: white"
          :loading="tableLoading"
          @click="analyzeFile"
        >开始解析导入文件</Button>
      </div>

      <div v-if="selectFile">
        <div class="file-box flex">
          <img src="./data/image/EXCEL.png" class="excelIcon" alt="">
          <span> {{ selectFile.name }}</span>
          <Icon
            type="ios-close-circle"
            size="18"
            class="cursor-pointer"
            style="margin-left: 4px; color: #333"
            @click="closeFile"
          ></Icon>
          <!-- <img
            src="./data/image/close.png"
            class="closeIcon"
            alt=""
            @click="closeFile"
          /> -->
        </div>
      </div>
    </div>
    <div>
      <div class="form-content-header">
        <span>导入文件解析结果</span>
      </div>
      <div class="stitle">成功解析的线下订单记录</div>
      <Table
        :loading="tableLoading"
        :data="dataSource"
        :columns="tableColumns"
        border
        :max-height="350"
      >
        <!-- <template slot-scope="{ row }" slot="reqMaterialType">
          <span>{{ row.reqMaterialType == 1 ? '是' : '否' }}</span>
        </template> -->
      </Table>
      <div class="page-wrap">
        <Page
          :total="pageInfo.total"
          show-total
          show-elevator
          @on-change="handlePageChange"
        ></Page>
      </div>

      <div class="stitle flex flexrow flexsb" style="margin-top: 30px">
        <div>解析<span style="color: red">异常</span>的线下订单记录</div>
        <Button
          type="text"
          :loading="downTempLoading"
          class="downfont"
          @click="downfailExcel"
        >点击下载异常数据</Button>
      </div>
      <Table
        :loading="tableLoading"
        :data="dataFailSource"
        :columns="tableFailColumns"
        :max-height="350"
        border
      >
        <!-- <template slot-scope="{ row }" slot="reqMaterialType">
          <span>{{ row.reqMaterialType == 1 ? '是' : '否' }}</span>
        </template> -->
      </Table>
      <div class="page-wrap">
        <Page
          :total="pageFailInfo.total"
          show-total
          show-elevator
          @on-change="handleFailPageChange"
        ></Page>
      </div>
      <div class="footer-main">
        <div class="flex justify-content" style="margin-left: -22%">
          <Button
            style="margin-right: 50px"
            @click="handleCancel('formValidate')"
          >取消</Button>
          <Button
            type="primary"
            @click="handleCfm('formValidate')"
          >确定导入</Button>
        </div>
      </div>
    </div>
    <Modal v-model="hintShow" :mask-closable="false" title="提示">
      <div>
        <h2>说明：</h2>
        <p>
          1、导入订单之前，请确保您已<span class="color-red">正确系统的课程商品名称、价格、课时等。</span>
        </p>
        <p>
          2、学生导入订单后，请选择合适的推送方式（未关注公众号的将无法手动微信推送）
        </p>
        <p>
          3、该操作不可恢复，请操作前<span class="color-red">务必核对清楚！</span>
        </p>
      </div>
      <div slot="footer">
        <div class="flex justify-content">
          <Button
            type="primary"
            size="large"
            style="width: 200px"
            @click="hintShow = false"
          >我已知晓上述说明！</Button>
        </div>
      </div>
    </Modal>
    <SmsCodeModal
      ref="smsCodeModalRef"
      :modal-title="`导入提示`"
      :check-type="`orderImport`"
      @sendCode="handleSendCode"
    >
      <template #header>
        <p style="margin-bottom: 8px">
          确认导入订单即表示对本次发起的订单导入确认无误，确认后系统即进行对应学生的订单生成，操作前请再次核对请订单的数据、节次及费用。该操作不可恢复，是否确认该操作？
        </p>
        <p>
          申请导入订单数：<span>{{ allCount }}</span> 正式导入订单数：<span
            class="color-blue"
          >{{ successCount }}</span>
          失败订单数：<span class="color-red">{{ failCount }}</span>
        </p>
      </template>
      <template #footer>
        <div class="content">
          <h2 style="margin-bottom: 10px">订单支付推送方式</h2>
          <div>
            <CheckboxGroup v-model="notifyChannels">
              <Checkbox
                label="1245"
                style="margin-right: 15px"
              >微信公众号推送<span class="color-gray">（家长需关注宏兔兔公众号）</span></Checkbox>
              <Checkbox label="1244">短信推送</Checkbox>
              <!-- <Checkbox label="西瓜"></Checkbox> -->
            </CheckboxGroup>
          </div>
        </div>
      </template>
    </SmsCodeModal>
    <ImportResult
      ref="importResultRef"
      :school-id="formValidate.schoolId"
      :task-id="taskId"
    ></ImportResult>
  </div>
</template>
<script>
import ImportTips from './components/ImportTips.vue';
import RemoteSelect from '@c/RemoteSelect';
import CascaderYearTerms from '@c/searchBlock/CascaderYearTerms.vue';
import ChooseApply from '@c/searchBlock/ChooseApply.vue';
import ChooseCampus from '@c/searchBlock/ChooseCampus.vue';
import SmsCodeModal from '@c/Base/SmsCodeModal.vue';
import ImportResult from './components/ImportResult.vue';
import {
  tableColumnsWidth,
  key,
  slot,
  renderFn
} from '@/assets/js/resetTableStyle';
import orderCenterApi from '@/request/orderCenter/index.js';
import { downLoadByBlob } from '@/pages/assetsModules/common.js';
import cateringAdmin from '@/request/cateringAdmin/index.js';
export default {
  components: {
    ImportTips, CascaderYearTerms, RemoteSelect, ChooseApply, ChooseCampus, SmsCodeModal, ImportResult
  },

  data() {
    return {
      loadingSchool: false, // 学校搜索框状态
      hintShow: true,
      tableLoading: false,
      downTempLoading: false,
      notifyChannels: [],
      dataFailSource: [],
      pageInfo: {
        pageSize: 10,
        pageNum: 1,
        total: 0
      },
      pageFailInfo: {
        pageSize: 10,
        pageNum: 1,
        total: 0
      },
      dataSource: [],
      allDataSource: [],
      allFailDataSource: [],
      successFileId: '',
      errFileId: '',

      tableColumns: [
        {
          title: '序号',
          type: 'index',
          width: 70,
          align: 'center'
        },
        key('课程商品ID', 'classroomId', tableColumnsWidth.type4),
        key('课程商品名称', 'classroomName', tableColumnsWidth.type4),
        key('课程提供方', 'orgName', tableColumnsWidth.type4),
        key('学生姓名', 'studentName', tableColumnsWidth.type2),
        key('年级班级', 'gradeClassName', tableColumnsWidth.type3),
        key('家长手机号码', 'phoneNo', tableColumnsWidth.type3),
        key('是否含材料费', 'reqMaterialType', tableColumnsWidth.type9, { align: 'center' }),
        key('材料费名称', 'materialName', tableColumnsWidth.type4)

      ],
      tableFailColumns: [
        {
          title: '序号',
          type: 'index',
          width: 70,
          align: 'center'
        },
        key('错误提示', 'result', tableColumnsWidth.type4),
        key('课程商品ID', 'classroomId', tableColumnsWidth.type4),
        key('课程商品名称', 'classroomName', tableColumnsWidth.type4),
        key('课程提供方', 'orgName', tableColumnsWidth.type4),
        key('学生姓名', 'studentName', tableColumnsWidth.type2),
        key('年级班级', 'gradeClassName', tableColumnsWidth.type3),
        key('家长手机号码', 'phoneNo', tableColumnsWidth.type3),
        key('是否含材料费', 'reqMaterialType', tableColumnsWidth.type9, { align: 'center' }),
        key('材料费名称', 'materialName', tableColumnsWidth.type4)

      ],
      schoolIdList: [],
      formValidate: {
        yearCode: '',
        termCode: '',
        schoolId: '',
        branchId: '',
        name: '1'
      },
      ruleValidate: {
        name: [
          { required: true, message: '', trigger: 'change' }
        ]

      },
      portOrg: localStorage.getItem('portOrg'),
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      selectFile: null,
      phoneCode: '',
      downloadToken: '',
      downloadUrl: '',
      taskId: ''
    };
  },
  computed: {
    // 校区选择提示
    Campusplaceholder() {
      return !this.formValidate.schoolId
        ? '请选择学校'
        : '请选择校区';
    },
    // 申请导入订单数
    allCount() {
      return this.allFailDataSource.length + this.allDataSource.length;
    },
    failCount() {
      return this.allFailDataSource.length;
    },
    successCount() {
      return this.allDataSource.length;
    }
  },
  created() {
    if (this.portOrg == 2) {
      this.formValidate.schoolId = this.userInfo.orgId;
    }
  },
  mounted() {
    // this.$refs.smsCodeModalRef.handleOpen()
  },
  activated() {
  },
  methods: {
    onCascaderChange(val) {
      this.formValidate.yearCode = val[0];
      this.formValidate.termCode = val[1];
      this.$nextTick(() => {
        this.$refs.chooseSchoolRef && this.$refs.chooseSchoolRef.handleClear();
        this.$refs.chooseCampusRef && this.$refs.chooseCampusRef.handleClear();
      });
    },
    handleSendCode(phoneCode) {
      this.phoneCode = phoneCode;
      // if (this.notifyChannels.length == 0) {
      //   this.$Message.warning('请选择要推送的方式！');
      //   return null;
      // }
      this.commitImportOrder();
    },
    async commitImportOrder() {
      const params = {
        fileId: this.successFileId,
        msgCode: this.phoneCode,
        schoolId: this.formValidate.schoolId
      };
      if (this.notifyChannels.length > 0) {
        params.channelTypes = this.notifyChannels;
      }
      const res = await orderCenterApi.commitImportOrder(params);
      if (res.status == 200) {
        this.taskId = res.message;
        this.$refs.smsCodeModalRef.handleClose();
        this.$nextTick(() => {
          this.$refs.importResultRef.handleShow(this.successCount);
        });
      }
    },

    onSchChange(val) {
      val.orgId ? '' : this.$refs.chooseCampusRef.handleClear();
      this.formValidate.schoolId = val.orgId;
    },
    // 校区选择
    handleCampusChange(val) {
      this.formValidate.branchId = val == -1 ? '' : val;
    },
    handleClick() {
      this.$refs.uploadInput.dispatchEvent(new MouseEvent('click'));
    },
    handleCancel() {
      this.$router.push({ name: 'orderCenter_order_orderTable' });
    },
    handleCfm() {
      if (this.dataSource.length == 0) {
        this.$Message.warning(`暂无导入数据，请重新上传文件进行解析～`);
        return null;
      }
      this.$refs.smsCodeModalRef.handleOpen();
    },
    // 下载token
    async getDownloadtoken(fileId) {
      return new Promise(async(resolve, reject) => {
        const params = {
          fileId: [fileId],
          type: 2
        };
        const res = await cateringAdmin.getDownloadtoken(params);
        if (res.status === 200) {
          this.downloadUrl = res.message.downUrl;
          this.downloadToken = res.message.token;
        }
        resolve();
      });
    },
    async downfailExcel() {
      await this.getDownloadtoken(this.errFileId);
      const href = `${this.downloadUrl}?fileId=${this.errFileId}&token=${this.downloadToken}`;

      const downloadElement = document.createElement('a');
      downloadElement.style.display = 'none';
      downloadElement.href = href;
      downloadElement.download = name; // 下载后文件名
      document.body.appendChild(downloadElement);
      downloadElement.click(); // 点击下载
      document.body.removeChild(downloadElement); // 下载完成移除元素
    },
    analyzeFile() {
      const res = this.checkForm();
      if (res.code != 200) {
        this.$Message.warning(res.error);
        return null;
      }
      if (!this.selectFile) {
        this.$Message.warning(`请选择上传文件`);
        return null;
      }
      this.parsingImportOrder();
    },
    async parsingImportOrder() {
      const formData = new FormData();
      formData.append('file', this.selectFile);
      ['schoolId', 'branchId', 'yearCode', 'termCode'].forEach(item => {
        formData.append(item, this.formValidate[item]);
      });
      this.tableLoading = true;
      const pioRes = await orderCenterApi.parsingImportOrder(formData);
      this.tableLoading = false;
      if (pioRes.status == 200) {
        // this.dataFailSource =  pioRes.message.errResultList
        // this.dataSource = pioRes.message.successResultList
        this.setDataFailSource(pioRes.message.errResultList);
        this.setDataSource(pioRes.message.successResultList);
        this.errFileId = pioRes.message.errFileId;
        this.successFileId = pioRes.message.successFileId;
      }
    },
    setDataSource(list) {
      this.dataSource = [];
      this.allDataSource = list;
      this.pageInfo.total = list.length;
      this.dataSource = Object.assign([], this.getPageData(this.pageInfo.pageNum, this.pageInfo.pageSize, list));
      //  this.loop(list.length, 0, list, 'dataSource')
    },
    setDataFailSource(list) {
      this.dataFailSource = [];
      this.allFailDataSource = list;
      this.pageFailInfo.total = list.length;
      this.dataFailSource = Object.assign([], this.getPageData(this.pageInfo.pageNum, this.pageFailInfo.pageSize, list));
      // this.loop(list.length, 0, list, 'dataFailSource')
    },
    getPageData(pageNum, pageSize, list,) {
      const start = pageNum * pageSize - pageSize; const end = pageNum * pageSize;
      const data = list.slice(start, end);
      return data;
    },
    // 切片插入
    loop(curTotal, curIndex, list, target) {
      if (curTotal <= 0) {
        return false;
      }
      // 每页多少条
      const pageCount = Math.min(curTotal, 30);
      window.requestAnimationFrame(() => {
        for (let i = 0; i < pageCount; i++) {
          this[target].push(list[curIndex + i]);
        }
        this.loop(curTotal - pageCount, curIndex + pageCount, list, target);
      });
    },
    inputFileChage(ev) {
      const kb = ev.target.files[0].size / 1024;
      if (kb > 20 * 1024 * 1024) {
        message.warning(`单个最大支持上传20M`);
        return null;
      }
      this.selectFile = ev.target.files[0];
      ev.target.value = '';
    },
    closeFile() {
      this.selectFile = null;
    },
    async downTemplateFile() {
      const res = this.checkForm();
      if (res.code != 200) {
        this.$Message.warning(res.error);
        return null;
      }
      delete res.data.branchId;
      this.downTempLoading = true;
      const tempRes = await orderCenterApi.getOrderImportTemplate(res.data);
      this.downTempLoading = false;
      downLoadByBlob(tempRes);
    },
    checkForm() {
      if (!this.formValidate.schoolId) {
        return {
          code: 500,
          error: '请选择学校'
        };
      }
      if (!this.formValidate.branchId) {
        return {
          code: 500,
          error: '请选择校区'
        };
      }
      if (!this.formValidate.yearCode) {
        return {
          code: 500,
          error: '请选择学期'
        };
      }
      const { yearCode, termCode, schoolId, branchId } = this.formValidate;
      return {
        code: 200,
        data: {
          yearCode,
          termCode,
          schoolId,
          branchId
        }
      };
    },
    handlePageChange(page) {
      this.pageInfo.pageNum = page;
      this.dataSource = Object.assign([], this.getPageData(page, this.pageInfo.pageSize, this.allDataSource));
    },
    handleFailPageChange(page) {
      this.pageInfo.pageNum = page;
      this.dataFailSource = Object.assign([], this.getPageData(page, this.pageFailInfo.pageSize, this.allFailDataSource));
    }
  }

};
</script>
  <style lang="scss" scoped>
.page-index {
  padding-bottom: 120px !important;
}
.form-content-header {
  background: rgba(0, 0, 0, 0.05);
  padding: 12px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-bottom: 16px;
  padding-left: 24px;
}

.stitle {
  padding: 10px 0 20px;
  font-weight: bold;
}

.file-box {
  /* width: 350px; */
  background-color: #c1efff;
  margin-top: 10px;
  padding: 5px 10px;
  color: #333;
  display: flex;
  align-items: center;
}

.uploadInput {
  display: none;
}

.fileWrap {
  margin-top: 15px;
  margin-bottom: 20px;
}

.excelIcon {
  width: 30px;
  margin-right: 10px;
}

.downfont {
  cursor: pointer;
  color: #0077ff;
  font-weight: bold;
  margin-left: 30px;
  margin-right: 10px;
}

.closeIcon {
  width: 20px;
  right: 10px;
  cursor: pointer;
  margin-left: 12px;
}
.footer-main {
  position: fixed;
  bottom: 0;
  width: 110%;
  left: 180px;
  background-color: #fff;
  z-index: 1000;
  padding: 20px 0;
  border-top: 1px solid #eee;
}
</style>

